import { useEffect } from 'react';

import { track, type AnalyticsEvent } from './track';

/**
 * Fire one funnel event when a page is first shown.
 *
 * Umami already records the pageview; these are the named funnel steps from
 * docs/marketing/metrics.md, which are what the stage-to-stage conversions are
 * actually computed from. Guarded against StrictMode's double effect in
 * development, so a local run does not report every step twice.
 */
export function usePageEvent(event: AnalyticsEvent, props?: Record<string, string | number | boolean>): void {
  useEffect(() => {
    track(event, props);
    // Fires once per mount by design: the props for these events describe the
    // page, not changing state, and re-firing would double-count the step.
  }, [event]);
}
